/**
 * AdminLayoutNew component — the layout shell for admin-facing pages.
 * Uses Tailwind design tokens -- no hardcoded hex colors.
 */
import React from 'react';

export interface AdminLayoutNewProps {
  children: React.ReactNode;
}

export function AdminLayoutNew({ children }: AdminLayoutNewProps): React.ReactElement {
  return (
    <div className="min-h-screen bg-surface-light dark:bg-surface-dark">
      <main className="max-w-7xl mx-auto px-4 py-6">
        {children}
      </main>
    </div>
  );
}
